import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LinePlaneFlyIcon from 'LuxKit/Icons/line/LinePlaneFlyIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import Group from 'components/utils/Group'
import React, { PropsWithChildren, ReactNode } from 'react'

interface Props extends Utils.PropsWithDataAttributes {
  callToAction: ReactNode
  title: 'Hotel' | 'Hotel + flights' | undefined;
  /**
   * This is not part of the LuxKit component
   *
   * Is experimentally used in an a/b test only, do not use this.
   */
  titleTrailingExperimental?: React.ReactNode;
}

function AccommodationPackageTilePricingBlock(props: PropsWithChildren<Props>) {
  const {
    callToAction,
    children,
    title,
    titleTrailingExperimental,
    ...rest
  } = props

  return <Group
    {...rest}
    direction="vertical"
    verticalAlign="space-between"
    gap={20}
  >
    <VerticalSpacer gap={8}>
      {title && <CaptionTextBlock
        variant="large"
        weight="bold"
        startIcon={title === 'Hotel + flights' && <LinePlaneFlyIcon />}
      >
        {title}{' '}{titleTrailingExperimental}
      </CaptionTextBlock>}
      {children && <div>{children}</div>}
    </VerticalSpacer>

    {callToAction && <Group direction="vertical" gap={8}>
      {callToAction}
    </Group>}
  </Group>
}

export default AccommodationPackageTilePricingBlock
